import { Action as _Action } from './src/actions';
export type Action<T, P> = _Action<T, P>;
export { actionCreator } from './src/actions';
export { createReducer } from './src/reducers';
